var map = {
	"./_card-1.svg": "97cd",
	"./_card-2.svg": "7242",
	"./_card-3.svg": "7b6c",
	"./_logo.svg": "2a6c",
	"./bells.svg": "38a4",
	"./cap.svg": "92b2",
	"./core-left.svg": "0af5",
	"./core-right.svg": "eeab",
	"./farming-left.svg": "fb11",
	"./farming-right.svg": "ae77",
	"./footer-cow-cap.svg": "8e56",
	"./footer-cow.svg": "ea71",
	"./gift.svg": "e0a0",
	"./landing-footer.svg": "96d0",
	"./landing-logo.svg": "f49c",
	"./milk-container.svg": "b180",
	"./shadow-staking.svg": "c2a0",
	"./switch.svg": "975e",
	"./team-left.svg": "59a9",
	"./team-right.svg": "8de4",
	"./tree.svg": "8a92"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5586";